import { useMutation } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { IAppleAdsInsertRequest } from "../../features/Campaigns/interface/appleAds";
import { IAppleSearchAdsResponse } from "../../features/Configurations/Integration/interface";

export const useInsertAppleAds = () => {
    return useMutation<IAppleSearchAdsResponse, Error, IAppleAdsInsertRequest>({
        mutationFn: async (payload) => {
            return httpService.post<IAppleSearchAdsResponse, IAppleAdsInsertRequest>(API_CONFIG.path.appleAdsSpending, payload);
        },
    });
};
